// extracted by css-extract-rspack-plugin
export default {"EmbeddingOptionIcon":"aK6Ul","Disabled":"KkFS8"};